export const ACCESS_ANALYSIS_BASE_URL = '/accessAnalysis/v2';

export const NUMBER_OF_ENTITIES_TO_FETCH = 50;
